import { Check as CheckIcon } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Navigate, useParams } from 'react-router-dom';

import * as routes from '../../../constants/Routing';
import { useNewUserPassword } from '../../../hooks/user/useNewUserPassword';
import { useValidateUserNewPasswordToken } from '../../../hooks/user/useValidateUserNewPasswordToken';
import Button from '../../../react-components/Button';
import { PasswordInput, validatePassword } from '../../../react-components/PasswordInput';
import Text from '../../../react-components/Text';

export const RecoveryReset = () => {
  const intl = useIntl();
  const { token } = useParams();
  const [password, setPassword] = useState<string>(``);
  const [password2, setPassword2] = useState<string>(``);
  const { success: tokenValid, run: getNewPasswordValidate } = useValidateUserNewPasswordToken();
  const { success: newPasswordSuccess, run: resetPassword } = useNewUserPassword();

  useEffect(() => {
    if (token) {
      getNewPasswordValidate({ token });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const handleResetPassword = () => {
    if (token && !isResetFormDisabled()) {
      resetPassword({ token, password });
    }
  };

  const isResetFormDisabled = () => {
    return (
      password !== password2 ||
      validatePassword(password).isValid === false ||
      validatePassword(password2).isValid === false
    );
  };

  return (
    <>
      {newPasswordSuccess && <Navigate to={routes.AUTH.LOGIN} />}

      {tokenValid && !newPasswordSuccess && (
        <Grid container direction="column" justifyContent="center" style={{ minHeight: `250px` }}>
          <Text intlId="auth.recovery.reset.info" variant="body" />

          <VSpacer />

          <Text variant="body" intlId="auth.recovery.reset.password" />

          <VSpacer small />

          <PasswordInput
            id="password"
            type="password"
            placeholder={intl.formatMessage({ id: `none` })}
            fieldValue={password}
            onChange={(psw: any) => setPassword(psw)}
            size="medium"
            variant="outlined"
            required
            onKeyDown={(ev) => {
              if (ev.keyCode === 13) {
                handleResetPassword();
              }
            }}
          />

          <VSpacer medium />

          <Text variant="body" intlId="auth.recovery.reset.confirm_password" />

          <VSpacer small />

          <PasswordInput
            id="password3"
            type="password"
            placeholder={intl.formatMessage({ id: `none` })}
            fieldValue={password2}
            onChange={(psw: any) => setPassword2(psw)}
            size="medium"
            variant="outlined"
            required
            showHints={false}
            onKeyDown={(ev) => {
              if (ev.keyCode === 13) {
                handleResetPassword();
              }
            }}
            validators={[
              {
                errorMessage: (
                  <Text tagName="span" style={{ color: RoutalPalette.danger }} intlId="password.confirm.errorhint" />
                ),
                isInvalid: (text?: string) => password !== text,
              },
            ]}
            endAdornment={
              <>
                {password !== `` && password === password2 && (
                  <CheckIcon style={{ color: RoutalPalette.success, marginRight: `5px` }} />
                )}
              </>
            }
          />

          <VSpacer />

          <Grid container justifyContent="center">
            <Button
              id="button_reset_password"
              buttonType="button"
              type="submit"
              size="large"
              onClick={handleResetPassword}
              disabled={isResetFormDisabled()}
              intlId="auth.recovery.request.button_reset_password"
              style={{
                width: `100%`,
              }}
            />
          </Grid>
        </Grid>
      )}

      {!tokenValid && (
        <Grid
          item
          container
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: `250px`, textAlign: `center` }}
        >
          <Text intlId="auth.recovery.reset.invalid_token" />
        </Grid>
      )}
    </>
  );
};
